const widgetHeights = {
    'large': 838,
    'medium': 600,
    'blocks': {
        'large': {
            'footer': 73,
            'title': 57,
        },
        'medium': {
            'footer': 73,
            'title': 57
        }
    }
}

const widgetWidths = {
    'large': 700,
    'medium': 450
}

// widgetSize - основной параметр который управляет дефолтным (стартовым) размером виджета LARGE (838px), MEDIUM (600px)
// адаптивность виджета сохраняется, то есть сжатие окна виджета на стороне пользователя использующего виджет
// на своей странице приводит к изменению его внутренней высоты и появлению вертикального скролла

export const widgetSizeParams = {
    setWidgetSizes(state, size) {
        if (size === 'medium') {
            state.widgetHeight = widgetHeights['medium']
            state.widgetWidth = widgetWidths['medium']
        } else {
            state.widgetHeight = widgetHeights['large']
            state.widgetWidth = widgetWidths['large']
        }

        const { withoutTitle, withoutFooter } = state

        if (withoutTitle) {
            state.widgetHeight = state.widgetHeight - widgetHeights.blocks[size].title
        }
        if (withoutFooter) {
            state.widgetHeight = state.widgetHeight - widgetHeights.blocks[size].footer
        }
    }
}